// extracted by mini-css-extract-plugin
export default {"inn":"FlashCertificateSelector_inn__YZfoD","select":"FlashCertificateSelector_select__jZA7R"};